<script setup lang="ts">
import { DataRow } from "@hantera/design-system";
import { useContext } from "@hantera/portal-app";
import { computed, ref, watch } from "vue";

const props = defineProps<{
  row?: DataRow
  selection?: unknown
}>()

const context = useContext()

// Use the persisted selection as the source of truth so the detail survives
// search/refresh even when the selected row is not on the loaded page.
const key = computed(() =>
  props.row?.key ?? (props.selection != null ? String(props.selection) : undefined)
)

const uri = computed(() => key.value ? '/sales/inventory/sku?id=' + key.value : undefined)

const state = ref<Record<string, any>>(context.currentView.value?.state?.detailsState ?? {})

watch(() => context.currentView.value?.state?.detailsState, () => {
  state.value = context.currentView.value?.state?.detailsState ?? {}
}, { deep: true })
watch(state, () => {
  if (!context.currentView.value) {
    return
  }
  context.currentView.value.state.detailsState = state.value
}, { deep: true })
</script>

<template>
  <EmbeddedView
    v-if="uri"
    :uri="uri"
    v-model:state="state"
  />
</template>

<style scoped></style>
